import React, { useState, useEffect } from 'react'
import { Container, Row, Col, Image } from "react-bootstrap";
import axios from 'axios';
import gradient from "../../Assets/gradient-hero-light.png";
import { Link } from "react-router";
const API_KEY = 'AIzaSyB7rUiiN_ez2J3pizCcY95ZUamGllIXeD4';
const BLOG_ID = '6116136833054324159';

export default function Blog() {
    const [posts, setPosts] = useState([]);

    useEffect(() => {
        const fetchPosts = async () => {
            try {
                const response = await axios.get(
                    `https://www.googleapis.com/blogger/v3/blogs/${BLOG_ID}/posts?key=${API_KEY}`
                );
                setPosts(response.data.items);
            } catch (error) {
                console.error('Error fetching posts:', error);
            }
        };

        fetchPosts();
    }, []);
    return (
        <div>
            <section className='bg-theme section-hero'>
                <Container fluid className="header-section">
                    <Row>
                        <Col md={12} >
                            <div className="padding-section-large text-center d-flex flex-column">
                                <div className="max-width-large mx-auto">
                                    <h1 className="heading-style-h1">Stay informed & <span className="text-white">inspired..</span></h1>
                                </div>
                                <div className='pt-2 max-width-medium mx-auto'>
                                    <p className="text-size-medium">We believe empowering organisations with the right data will create environments where both businesses and employees can thrive.</p>
                                </div>
                                <div className="pt-3 d-flex justify-content-center">
                                    <Link to="/contact" className="btn btn-dark rounded-pill px-5 py-3">Get In Touch</Link>
                                </div>
                            </div>
                        </Col>
                        <div className="pills-wrap">
                            <div className="hero-pill-left-wrap animation_slide-up-delay-2">
                                <Image src={gradient} />
                            </div>
                            <div className="hero-pill-right-wrap animation_slide-up-delay-2">
                                <Image src={gradient} />
                            </div>
                        </div>
                    </Row>
                </Container >
            </section >
            <Container fluid className="about-section">
                <Container>
                    <ul>
                        {posts.map((post) => (
                            <div className='mb-4'>
                                <div className='alert alert-dark d-flex flex-column'>
                                    <div key={post.id}>
                                        <h2>{post.title}</h2>
                                        <p>
                                            Published:{' '}
                                            {new Date(post.published).toLocaleString()}
                                        </p>
                                        <div dangerouslySetInnerHTML={{ __html: post.content }} />
                                    </div>
                                </div>
                            </div>
                        ))}
                    </ul>
                </Container>
            </Container>
        </div >
    )
}
